module.exports = __webpack_public_path__ + "static/img/zzzs.da1431f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/zzzs.jpg
// module id = 5pC7
// module chunks = 0